"use strict";

var _interopRequireDefault = require("/var/www/html/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAcceptDepartmentOption = getAcceptDepartmentOption;
exports.getChannelGroupOption = getChannelGroupOption;
exports.getFailedReasonOption = getFailedReasonOption;
exports.getFunnelAnalysisOrderDetail = getFunnelAnalysisOrderDetail;
exports.getFunnelAnalysisOrderDetailExport = getFunnelAnalysisOrderDetailExport;
exports.getFunnelAnalysisStatisticsDetail = getFunnelAnalysisStatisticsDetail;
exports.getFunnelAnalysisStatisticsDetailExport = getFunnelAnalysisStatisticsDetailExport;
exports.getFunnelAnalysisStatisticsSummary = getFunnelAnalysisStatisticsSummary;
exports.getGuideDepartmentOption = getGuideDepartmentOption;
exports.getNoGuideOrder = getNoGuideOrder;
exports.getPatternOption = getPatternOption;
var _request = _interopRequireDefault(require("@/utils/request"));
// 强导漏斗分析（大数据接口）
// 文档：https://yapi.linghit.cn/project/1065/interface/api/cat_14800

var type = 'bigData';

// 强导漏斗分析-获取统计汇总数据
function getFunnelAnalysisStatisticsSummary() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    type: type,
    url: '/getFunnelAnalysisStatisticsSummary',
    method: 'post',
    data: data
  });
}

// 获取统计详情数据
function getFunnelAnalysisStatisticsDetail() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    type: type,
    url: '/getFunnelAnalysisStatisticsDetail',
    method: 'post',
    data: data
  });
}

// 获取订单详情
function getFunnelAnalysisOrderDetail() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    type: type,
    url: '/getFunnelAnalysisOrderDetail',
    method: 'post',
    data: data
  });
}

// 获取统计详情数据导出
function getFunnelAnalysisStatisticsDetailExport() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    type: type,
    url: '/getFunnelAnalysisStatisticsDetailExport',
    method: 'post',
    data: data
  });
}

// 获取订单详情导出
function getFunnelAnalysisOrderDetailExport() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    type: type,
    url: '/getFunnelAnalysisOrderDetailExport',
    method: 'post',
    data: data
  });
}

// 获取导粉部门（流量分发部门）选项
function getGuideDepartmentOption() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    type: type,
    url: '/getDaofenDepartmentOption',
    method: 'post',
    data: data
  });
}

// 获取接粉部门（流量接收部门）选项
function getAcceptDepartmentOption() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    type: type,
    url: '/getJiefenDepartmentOption',
    method: 'post',
    data: data
  });
}

// 获取渠道载体（渠道分类）选项
function getChannelGroupOption() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    type: type,
    url: '/getChannelZaitiOption',
    method: 'post',
    data: data
  });
}

// 获取分发模型选项
function getPatternOption() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    type: type,
    url: '/getPatternOption',
    method: 'post',
    data: data
  });
}

// 获取失败原因选项
function getFailedReasonOption() {
  return (0, _request.default)({
    type: type,
    url: '/getFailureReasonOption',
    method: 'post',
    data: {
      type: 'object',
      title: 'title',
      properties: {}
    }
  });
}

/**
 * 获取可导但未导的订单
 * @param {string} guideDepartment 导粉部门
 */
function getNoGuideOrder(guideDepartment) {
  return (0, _request.default)({
    type: type,
    url: '/getKedaoNodaoOrder',
    method: 'post',
    data: {
      daofen_department: guideDepartment
    }
  });
}